import { ColorPicker } from "primereact/colorpicker";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useState } from "react";
import Http from "../../../Common/Http";

const Create = ({ setVisible, fetchData }) => {
  const [inputs, setInputs] = useState({
    name: "",
    color: "#3B82F6",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleColorChange = (e) => {
    const color = `#${e.value}`;
    setInputs((prev) => ({ ...prev, color }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Ensure all fields have values
    const formData = {
      name: inputs.name.trim(),
      color: inputs.color.trim(),
    };

    try {
      const res = await Http.post(`/label/store`, formData);

      if (res.data) {
        setVisible(false);
        fetchData();
      }
    } catch (error) {
      setError("Failed to create label. Please try again.");
      console.error("Create error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Common color presets
  const commonColors = [
    { name: "Blue", color: "#3B82F6" },
    { name: "Green", color: "#10B981" },
    { name: "Red", color: "#EF4444" },
    { name: "Yellow", color: "#F59E0B" },
    { name: "Purple", color: "#8B5CF6" },
    { name: "Pink", color: "#EC4899" },
    { name: "Indigo", color: "#6366F1" },
    { name: "Gray", color: "#6B7280" },
  ];

  return (
    <div>
      {loading ? (
        <div className="text-center">
          <ProgressSpinner />
        </div>
      ) : (
        <div className="container">
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-lg-12">
                <label htmlFor="name" className="form-label">
                  Label Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  id="name"
                  value={inputs.name}
                  onChange={handleInputChange}
                  placeholder="Enter label name (e.g., Urgent, High Priority, Feature)"
                  required
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-lg-12">
                <label htmlFor="color" className="form-label">
                  Color
                </label>
                <div className="d-flex align-items-center">
                  <div
                    className="color-preview mr-3"
                    style={{
                      width: "30px",
                      height: "30px",
                      backgroundColor: inputs.color,
                      borderRadius: "4px",
                      marginRight: "10px",
                      border: "1px solid #ddd",
                    }}
                  ></div>
                  <input
                    type="text"
                    className="form-control"
                    name="color"
                    value={inputs.color}
                    onChange={handleInputChange}
                    placeholder="Enter color code (e.g., #FF0000)"
                  />
                  <ColorPicker value={inputs.color.replace("#", "")} onChange={handleColorChange} className="ml-2" />
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-lg-12">
                <label className="form-label d-block">Common Colors</label>
                <div className="d-flex flex-wrap gap-2">
                  {commonColors.map((item) => (
                    <button
                      key={item.color}
                      type="button"
                      className={`btn btn-sm ${inputs.color === item.color ? "btn-primary" : "btn-outline-secondary"}`}
                      onClick={() => setInputs((prev) => ({ ...prev, color: item.color }))}
                    >
                      <div
                        style={{
                          width: "15px",
                          height: "15px",
                          backgroundColor: item.color,
                          borderRadius: "2px",
                          display: "inline-block",
                          marginRight: "5px",
                        }}
                      ></div>
                      {item.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="preview-box p-3 mb-3" style={{ border: "1px solid #ddd", borderRadius: "4px" }}>
                  <h6>Preview:</h6>
                  <div className="d-flex align-items-center">
                    <span className="badge" style={{ backgroundColor: inputs.color, color: "#fff", padding: "8px 12px", borderRadius: "4px" }}>
                      {inputs.name || "Label"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <button type="submit" className="btn btn-primary float-end">
                  Create Label
                </button>
                <button type="button" className="btn btn-secondary float-end me-2" onClick={() => setVisible(false)}>
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default Create;
